<template>
  <div class="container-fluid">
    <div v-if="isLoading" class="loading-container">
      <div class="loader"></div>
    </div>

    <MainHeader :token="token" :key="$route.fullPath" />
    <BannerNoticias style="margin-top: 76px" />
    <MainSidebar :token="token" :key="$route.fullPath" />

    <div :class="{
      'pt-5': !this.$nlhpc.hasNoticias(),
      'mt-3': !this.$nlhpc.hasNoticias(),
      'main-column-master': true,
      blur: isLoading,
      'ms-5': !this.isSmallScreen() && this.$nlhpc.isLoggedIn(),
    }">
      <div id="nlhpc-master" class="px-0">
        <Transition name="fade" mode="out-in">
          <router-view v-slot="{ Component }" :key="$route.fullPath">
            <component :is="Component" />
          </router-view>
        </Transition>
      </div>
      <MainFooter />
    </div>

    <div class="modal fade" id="modalIntroJS" tabindex="-1" aria-labelledby="modalIntroJSLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content bg-light">
          <div class="modal-body" style="color: black">
            <div class="row">
              <div class="col text-center">
                <img class="mb-2" :src="require('@/assets/img/logocolor.png')" width="200" />
              </div>
            </div>
            <hr />
            <div class="container">
              <div class="row">
                <div class="col">
                  <h4>
                    <b>NLHPC Dashboard 2.0</b>
                  </h4>
                  <p id="introBienvenida" style="text-align: justify; padding-left: 10px; padding-right: 10px">
                    ¡Bienvenidos(as) al Dashboard del Laboratorio Nacional de Computación
                    de Alto Rendimiento de la Universidad de Chile!
                  </p>
                  <p id="introBody" style="text-align: justify; padding-left: 10px; padding-right: 10px">
                    A continuación lo invitamos a realizar un tour guiado, donde les
                    mostraremos paso a paso cómo navegar por la nueva interfaz y acceder a
                    todas sus funcionalidades.
                    <br />
                  </p>
                </div>
              </div>
            </div>
          </div>

          <hr />

          <div class="px-4 pb-3">
            <div class="row">
              <div class="col-5 text-start">
                <label style="color: black; cursor: pointer; margin-top: 6px" for="inputDontShow">
                  <input id="inputDontShow" class="form-check-input" type="checkbox"
                    aria-label="Checkbox for following text input" v-model="inputDontShow" />
                  <small class="text-decoration-underline" style="color: black; font-size: small">
                    No volver a mostrar
                  </small>
                </label>
              </div>
              <div class="col-7 text-end">
                <a class="text-decoration-underline" data-bs-dismiss="modal" style="
                    color: black;
                    font-size: small;
                    margin-right: 25px;
                    cursor: pointer;
                  ">
                  Quizás más tarde
                </a>
                <button type="button" class="btn btn-primary" @click="showIntroJS()" data-bs-dismiss="modal">
                  Continuar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- eslint-disable no-undef -->
<script>
import "@/assets/css/charts.css";
import "@/assets/css/animate.css";
import "@/assets/css/style.css";
import "@/assets/css/introjs.css";

import MainSidebar from "@/components/MainSidebar.vue";
import MainHeader from "@/components/MainHeader.vue";
import MainFooter from "@/components/MainFooter.vue";
import BannerNoticias from "@/components/BannerNoticias.vue";
import axios from "axios";

export default {
  name: "App",
  components: {
    MainSidebar,
    MainHeader,
    MainFooter,
    BannerNoticias,
  },

  data() {
    return {
      token: String,
      isLoading: true,
      user: null,
      inputDontShow: false,
      steps: [],
      voiceEnabled: true,
    };
  },

  watch: {
    inputDontShow(newValue) {
      localStorage.setItem("introjsComplete", newValue);
    },
  },

  created() {
    this.isLogin();
    this.renewToken();
    this.setSteps();
  },

  updated() {
    this.isLogin();
    this.renewToken();
    this.messageWarning();
  },

  mounted() {
    setTimeout(() => {
      this.isLoading = false;
      this.runIntroJS();
    }, 2000);

    this.user = this.$nlhpc.getUser();

    setInterval(() => {
      this.renewToken();
    }, 20 * 60 * 1000);
  },

  onIdle() {
    // if (this.user.is_ir || this.user.admin) return;
    // this.closeSession();
  },

  methods: {
    isLogin() {
      this.token = this.$nlhpc.getBearerToken();
      if (process.env.VUE_APP_MODE === "development")
        this.token ? console.log("Estamos logueados!") : console.log("Sesión cerrada!");
    },

    runIntroJS() {
      let path = this.$route.path;
      let showAgain = localStorage.getItem("showAgain");
      if (path.includes("dashboard") || path == "/") {
        if (window.innerWidth >= 800) {
          let cookieFile = localStorage.getItem("introjsComplete");
          this.inputDontShow = cookieFile == "true" ? true : false;
          if (showAgain || !this.inputDontShow) {
            this.setSteps();
            localStorage.removeItem("showAgain");
            // setTimeout(() => {
            //   let intro1 = document.querySelector("#introBienvenida").innerText;
            //   let intro2 = document.querySelector("#introBody").innerText;
            //   this.speakText(`${intro1}. ${intro2}`);
            // }, 1000);
            $("#modalIntroJS").modal("show");
          }
        }
      }
    },

    showIntroJS() {
      const self = this;
      introJs()
        .setOptions({
          doneLabel: "Continuar",
          prevLabel: "Anterior",
          nextLabel: "Siguiente",
          dontShowAgain: false,
          dontShowAgainLabel: "No volver a mostrar",
          buttonClass: "btn btn-sm btn-primary",
          tooltipClass: "introJSContainer",
          disableInteraction: true,
          exitOnOverlayClick: false,
          showBullets: true,
          steps: this.steps,
          html: true,
        })
        .onafterchange((data) => {
          let buttonBefore = document.querySelector(".introjs-prevbutton");

          // setTimeout(() => {
          //   let button = document.querySelector(`#${data.id}Button`);
          //   if (!button) return;
          //   button.onclick = function () {
          //     let index = button.value;
          //     let elem = self.steps.find((item) => item.title.includes(data.id));
          //     let icon = self.toggleVoz(self.stripHtml(elem.intro));
          //     button.innerHTML = icon;
          //   };
          // }, 500);
        })
        .onbeforechange(async (data) => {
          let width = window.innerWidth;
          let element = document.querySelectorAll(".introJSContainer");

          if (data?.className?.includes("introjsFloatingElement")) {
            if (width >= 800) element.forEach((item) => (item.style.minWidth = "800px"));
            else element.forEach((item) => (item.style.minWidth = `${width}px`));
          } else {
            let modal = document.querySelector(".introJSContainer");
            if (modal) modal.style.minWidth = "300px";
          }
        })
        .onchange(function (data) {
          const currentStepIndex = this._currentStep;
          const currentStep = this._options.steps[currentStepIndex];
          if (!data.id) return;

          // if (currentStep && currentStep.intro) {
          //   let intro = self.stripHtml(currentStep.intro);
          //   self.speakText(intro);
          //   setTimeout(() => {
          //     let icon = self.getIcon();
          //     let button = document.querySelector(`#${data.id}Button`);
          //     button.innerHTML = icon;
          //   }, 500);
          // }
        })
        .start();
    },

    getIcon() {
      if (this.voiceEnabled) return `<i class="fa-solid fa-volume-high"></i>`;
      else return `<i class="fa-solid fa-volume-xmark"></i>`;
    },

    setSteps() {
      this.steps = [
        {
          view: ["user", "ir", "guest"],
          element: document.getElementById("buttonHeaders"),
          title: `Menú de navegación `,
          // title: `<button id="buttonHeadersButton">${this.getIcon()}</button><br>Menú de navegación `,
          intro: `<p>Accede rápidamente a herramientas clave como nuestra <strong>Wiki</strong>, el <strong>Generador de Scripts</strong>,opción de alternar entre los modos claro y oscuro del dashboard entre otras.</p>`,
          position: "left",
        },
        {
          view: ["user", "ir"],
          element: document.getElementById("loginPhoto"),
          title: `Menú de usuario `,
          // title: `<button id="loginPhotoButton">${this.getIcon()}</button><br>Menú de usuario `,
          intro: `<p>Desde aquí puedes gestionar tu cuenta: revisar tus datos personales o cerrar sesión de forma segura.</p>`,
          position: "left",
        },
        {
          view: ["user", "ir", "guest"],
          element: document.getElementById("mainCarouselNews"),
          title: `Noticias y comunicados `,
          // title: `<button id="mainCarouselNewsButton">${this.getIcon()}</button><br>Noticias y comunicados `,
          intro: `<p>Infórmate sobre <strong>eventos, cursos, mantenimientos</strong> y otros avisos relevantes para la comunidad NLHPC.</p>`,
          position: "bottom",
        },
        {
          view: ["user", "ir"],
          element: document.getElementById("mainSidebar"),
          title: `Barra lateral`,
          intro: `
            <p>En esta barra puedes acceder a las principales funcionalidades del sistema:</p>
            <ul>
              <li><strong>Dashboard:</strong> vuelve a la vista principal para obtener una visión general de tus recursos, actividades recientes y accesos rápidos.</li>
              <li><strong>Noticias:</strong> revisa todos los anuncios y comunicados relevantes del sistema, con el contenido completo y sin resúmenes.</li>
              <li><strong>Solicitudes:</strong> envía requerimientos administrativos como ampliaciones de recursos, incorporación de usuarios o reserva de nodos, utilizando el canal formal de comunicación con el equipo del NLHPC.</li>
            </ul>
          `,
          position: "right",
        },
        {
          view: ["user", "ir", "guest"],
          element: document.getElementById("panalContainerTitle"),
          title: `Título de visualización `,
          // title: `<button id="panalContainerTitleButton">${this.getIcon()}</button><br>Título de visualización `,
          intro: `<p>Este título refleja la métrica actual que estás visualizando en el panal de nodos (CPU, GPU, RAM, etc.).</p>`,
        },
        {
          view: ["user", "ir", "guest"],
          element: document.getElementById("panalContainerSwitch"),
          title: `Botones de visualización `,
          // title: `<button id="panalContainerSwitchButton">${this.getIcon()}</button><br>Botones de visualización `,
          intro: `<p>Selecciona el tipo de recurso que deseas visualizar en el panal:</p>
          <ul>
          <li><strong>CPU:</strong> Uso de procesadores</li>
          <li><strong>GPU:</strong> Uso de unidades gráficas</li>
          <li><strong>CPU-RAM:</strong> Uso de memoria en nodos CPU</li>
          <li><strong>GPU-RAM:</strong> Uso de memoria en nodos GPU</li>
          </ul>
          `,
        },
        {
          view: ["user", "ir", "guest"],
          element: document.getElementById("PanalContainerPartition"),
          title: `Particiones de nodos de cómputo `,
          // title: `<button id="PanalContainerPartitionButton">${this.getIcon()}</button><br>Particiones de nodos de cómputo `,
          intro: `<p>Utiliza esta barra para explorar el estado general o segmentado por partición del clúster. Es útil para identificar la disponibilidad específica y carga actual de los nodos. La barra de navegación permite seleccionar una visión general o específica de cada partición disponible en el clúster.</p>`,
        },
        {
          view: ["user", "ir", "guest"],
          element: document.getElementById("containerPanal"),
          title: `Panal de nodos de cómputo `,
          // title: `<button id="containerPanalButton">${this.getIcon()}</button><br>Panal de nodos de cómputo `,
          intro: `<p>Visualización gráfica del estado de los nodos de cómputo.</p><p>Cada hexágono representa un nodo. Puedes <strong>hacer clic para obtener información detallada</strong> sobre su uso.</p>`,
          position: `right`,
        },
        {
          view: ["user", "ir", "guest"],
          title: `Modal Nodo `,
          // title: `<button id="voiceButton" value='10'>${this.getIcon()}</button><br>Modal Nodo `,
          intro: `<div class="row"><div class="col-12">
              <img style="width:100%;" src="${require("@/assets/img/modal-nodo-cpu.png")}" />
              </div><div class="col-12">
              <p><br/>Muestra la cantidad de CPUs utilizadas, disponibles y el porcentaje de uso. También incluye un gráfico de carga actualizado cada minuto.</p>
              </div></div>`,
        },
        {
          view: ["user", "ir", "guest"],
          title: `Modal Nodo `,
          // title: `<button id="voiceButton">${this.getIcon()}</button><br>Modal Nodo `,
          intro: `<div class="row"><div class="col-12">
              <img style="width:100%;" src="${require("@/assets/img/modal-nodo-ram.png")}" />
              </div><div class="col-12">
              <p><br/>Despliega la memoria RAM reservada, disponible y el porcentaje de uso. Se incluye además un gráfico de evolución temporal.</p>
              </div></div>`,
        },
        {
          view: ["user", "ir", "guest"],
          element: document.getElementById("panalContainerFooter"),
          title: `Mapa de colores `,
          // title: `<button id="panalContainerFooterButton">${this.getIcon()}</button><br>Mapa de colores `,
          intro: `<p>La escala de colores permite identificar rápidamente el <strong>nivel de uso y estado de cada nodo</strong> en el clúster.</p>`,
          position: "top",
        },
        {
          view: ["user", "ir", "guest"],
          element: document.getElementById("dashboardTacometer"),
          title: `Tacómetro de CPU y estado del Cluster `,
          // title: `<button id="dashboardTacometerButton">${this.getIcon()}</button><br>Tacómetro de CPU y estado del Cluster `,
          intro: `<p>Visualización en tiempo real del <strong>porcentaje de CPUs utilizadas</strong> en el clúster.</p><p>También muestra la cantidad total y disponible de CPUs y memoria RAM.</p>`,
          position: "left",
        },
        {
          view: ["user"],
          element: document.getElementById("dashboardBarUser"),
          title: `Recursos Utilizados / Asignados `,
          // title: `<button id="dashboardBarUserButton">${this.getIcon()}</button><br>Recursos Utilizados / Asignados `,
          intro: `<p>Panel que muestra los <strong>recursos asignados a tu cuenta</strong>, incluyendo CPUs, almacenamiento y horas de cómputo.</p>
          <p>Incluye una vista gráfica del uso dentro del equipo de investigación.</p>
          `,
          position: "left",
        },
        {
          view: ["ir"],
          element: document.getElementById("BoxUserIR"),
          title: `Resumen de Proyecto `,
          // title: `<button id="BoxUserIRButton">${this.getIcon()}</button><br>Resumen de Proyecto `,
          intro: `<p>Resumen general del proyecto: visualiza la <strong>información administrativa</strong>, las <strong>horas de cómputo otorgadas y utilizadas</strong> y los <strong>recursos asignados</strong>.</p>`,
          position: "left",
        },
        {
          view: ["ir"],
          element: document.getElementById("tableUsersIR"),
          title: `Tabla de usuarios `,
          // title: `<button id="tableUsersIRButton">${this.getIcon()}</button><br>Tabla de usuarios `,
          intro: `<p>Lista detallada de los recursos asignados y utilizados de los <strong>usuarios  del proyecto</strong>.</p>`,
          position: "left",
        },
        {
          view: ["user"],
          element: document.getElementById("clusterTableJobs"),
          title: `Tabla de tareas en ejecución `,
          // title: `<button id="clusterTableJobsButton">${this.getIcon()}</button><br>Tabla de tareas en ejecución `,
          intro: `<p>Revisa las tareas que has enviado al clúster, con detalles sobre su estado actual.</p><p>Puedes <strong>filtrar por fecha</strong> y <strong>exportar en formato CSV</strong> para su análisis o respaldo.</p>`,
          position: "top",
        },
        {
          view: ["user", "ir", "guest"],
          element: document.getElementById("dashboardClusterTable"),
          title: `Tabla de resumen de particiones `,
          // title: `<button id="dashboardClusterTableButton">${this.getIcon()}</button><br>Tabla de resumen de particiones `,
          intro: `<p>Tabla que muestra el estado de cada partición del clúster: <strong>tareas en ejecución y espera, nodos disponibles, uso de CPU y RAM</strong>.</p><p>Es fundamental para evaluar la carga del sistema y planificar el envío de trabajos.</p>`,
          position: "top",
        },
        {
          view: ["user", "ir", "guest"],
          title: ``,
          // title: `<button id="dashboardClusterTableButton">${this.getIcon()}</button><br>Tabla de resumen de particiones `,
          intro: `<div class="text-center">
          <h3>¡Tour finalizado con éxito!<br><br></h3>
          <p>Ya conoces las principales herramientas del dashboard.
            <br>Ahora es tu turno: explora, consulta noticias, gestiona tus solicitudes <br>y sácale el máximo provecho a la plataforma.</p>
            <p>¡Estamos aquí para ayudarte a avanzar más rápido!</p></div>`,
          position: "top",
        },
      ];

      this.filterSteps();
    },

    filterSteps() {
      let tipo = this.user?.is_ir ? "ir" : "user";
      tipo = this.$nlhpc.isLoggedIn() ? tipo : "guest";
      this.steps = this.steps.filter((item) => item.view.includes(tipo));
    },

    async renewToken() {
      if (!this.token) return;

      try {
        // if (localStorage.getItem("user").includes("is_ir")) return;
        let isTokenValid = await this.$nlhpc.validateToken(this.token);

        if (!isTokenValid) this.closeSession("Token expirado, vuelva a iniciar sesión");

        if (this.$nlhpc.getUser().is_ir) {
          if (process.env.VUE_APP_MODE === "development")
            console.log("No se renueva el token porque es IR");
          return;
        }

        const API_BASE_URL = process.env.VUE_APP_API_URL;
        const options = {
          method: "POST",
          url: `${API_BASE_URL}/login/renew_token`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        };

        let request = await axios.request(options);

        if (request.status == 200) {
          localStorage.setItem("token", request.data.accessToken);
          this.token = localStorage.getItem("token");
          return;
        }

        if (request.status == 202 || request.status == 500) {
          return;
        }

        this.closeSession("Se ha cerrado la sesión por seguridad.");
      } catch (error) {
        if (process.env.VUE_APP_MODE === "development")
          console.log("Error al renovar token", error);
        this.closeSession();
      }
    },

    speakText(text) {
      if (!this.voiceEnabled) return;

      const synth = window.speechSynthesis;
      const utterance = new SpeechSynthesisUtterance(text);

      utterance.lang = "es-ES";
      utterance.pitch = 1;
      utterance.rate = 1;
      synth.cancel();
      synth.speak(utterance);
    },

    isSmallScreen() {
      let width = Number(window.innerWidth);
      this.smallScreen = width < 1200 ? true : false;
      return this.smallScreen;
    },

    toggleVoz(text = null) {
      const synth = window.speechSynthesis;
      this.voiceEnabled = !this.voiceEnabled;
      if (synth.speaking) synth.cancel();
      else this.speakText(text);
      return this.getIcon();
    },

    closeSession(msg = false, showAlert = true) {
      if (!this.token) return;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      this.token = null;

      if (!showAlert) location.href = "/login";

      let message =
        msg || "Su sesión ha sido cerrada por inactividad, vuelva a iniciar sesión";

      this.$swal({
        // title: `Sesión cerrada`,
        title: `Sesión cerrada`,
        text: message,
        icon: "info",
        confirmButtonColor: "red",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-danger",
        },
      }).then((result) => {
        if (result.isConfirmed || result.isDismissed) location.href = "/login";
      });
    },

    stripHtml(htmlString) {
      return (
        new DOMParser().parseFromString(htmlString, "text/html").body.textContent || ""
      );
    },

    messageWarning() {
      console.log("%c¡Detente!", "color: red; font-size: 40px; font-weight: bold;");
      console.log(
        "%cNo escribas ni pegues código aquí.\nCualquier comportamiento sospechoso será notificado.",
        "color: gray; font-size: 16px;"
      );
    },
  },
};
</script>

<style>
.introJSContainer {
  min-width: 300px;
  min-height: 200px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

.toggle-voz {
  cursor: pointer;
}
</style>
